import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { Role } from '../auth/roles';

export function roleGuard(...roles: Role[]): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const allowed = roles.some((role) => authService.hasRole(role));
    return allowed ? true : router.parseUrl('/');
  };
}
